import React from 'react';
import Logo from './Logo';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { initialSignupState } from '../../../store/signup/reducer';
import { pushEvent } from '../../../utils/clevertapUtils';
import { CLICK_BACK, CLICK_CLOSE } from '../../../utils/clevertapEvents';
import Label16 from '../../../theme/labels/Label16';
import { useTranslation } from 'react-i18next';
import { useWrapperStyles } from './SignupContentWrapper';
import { webConfig } from '../../../webConfig';
import backIcon from '../../../assets/back-icon.svg';
import crossIcon from '../../../assets/cross-icon.svg';

const GIVELIFY_HOME_PAGE_URL = webConfig.givelifyHomePageUrl;

interface HeaderProps {
    hideLogo?: true;
    backUrl: string | undefined;
    showCloseButton: true | undefined;
    onBackClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({
    backUrl,
    showCloseButton,
    hideLogo,
    onBackClick,
}) => {
    const dispatch = useAppDispatch();
    const push = useNavigate();
    const { t } = useTranslation();
    const backText = t('labels.back');
    const { headerStyles } = useWrapperStyles();

    const showBackButton = Boolean(backUrl || onBackClick)
    const backClassName = showBackButton ? 'back cursor' : 'back hide';

    const onBack = () => {
        pushEvent(CLICK_BACK);
        if (backUrl) {
            push(backUrl);
        } else {
            onBackClick?.();
        }
    };

    const onClose = () => {
        pushEvent(CLICK_CLOSE);
        dispatch(signSetAction(initialSignupState));
        window.location.href = GIVELIFY_HOME_PAGE_URL;
    };
    return (
        <div className={headerStyles}>
            <div className="header">
                <div onClick={onBack} className={backClassName}>
                    <img src={backIcon} alt={backText} title={backText} />
                    <Label16 className="back-label">{backText}</Label16>
                </div>
                {!hideLogo && <Logo className="logo" />}
                <img
                    src={crossIcon}
                    alt="close"
                    title="close"
                    onClick={onClose}
                    className={showCloseButton ? 'cursor' : 'hide'}
                />
            </div>
        </div>
    );
};
export default Header;
